import {
  DefineDevice,
  VirtualHE3SEWireless_24g,
  VirtualHE3SEWireless,
  VirtualMu68_ULTRA,
  VirtualMu68Pro,
  VirtualMu68Pro_Cyan,
  VirtualNa87ProWired,
  VirtualNd63,
  VirtualNd63_Cyan,
  VirtualPolar75,
  RoYuanDevice,
  JingTaiMg75Devices,
  JingTaiMer68Devices,
  VirtualHe6Ultra,
  VirtualHe6Ultra_24g,
  JingTaiV2Devices,
  Fe87v2Devices,
  VirtualMer68SESelfDev,
  HuoChaiRenDevices,
  ZhiHuiWuXian_Device,
} from '@hid/define/define'
import { DeviceProtocol } from '../device/device_model'
import { he3Driver } from '@hid/driver/he3'
import { na87Driver } from '@hid/driver/na87'
import { nd68Driver } from './nd68'
import { he6UltraDriver } from './he6_ultra'
import { jingtaiV2Driver } from './jingtai_v2'
import { fe87v2Driver } from './fe87v2'
import { mg63Driver } from './huochairen'
import { ZHWXDriver } from './zhihuiwuxian'

export async function getDriverIns(id: DefineDevice, protocol: DeviceProtocol) {
  if (id == VirtualHE3SEWireless_24g || id == VirtualHE3SEWireless) {
    return new he3Driver(protocol)
  }
  if (id == VirtualNa87ProWired || id == VirtualMu68Pro || id == VirtualNd63 || id == VirtualMu68Pro_Cyan || id == VirtualMu68_ULTRA || id == VirtualPolar75 || id == VirtualNd63_Cyan) {
    return new na87Driver(protocol)
  }
  if (Fe87v2Devices.includes(id) || id == VirtualMer68SESelfDev) {
    return new fe87v2Driver(protocol)
  }
  if (HuoChaiRenDevices.includes(id)) {
    return new mg63Driver(protocol)
  }
  if ([...JingTaiMer68Devices, ...JingTaiMg75Devices].includes(id)) {
    return new na87Driver(protocol)
  }
  if (RoYuanDevice.includes(id)) {
    return new nd68Driver(protocol)
  }
  if (id == VirtualHe6Ultra || id == VirtualHe6Ultra_24g) {
    return new he6UltraDriver(protocol)
  }
  if (ZhiHuiWuXian_Device.includes(id)) {
    return new ZHWXDriver(protocol)
  }
  if (JingTaiV2Devices.includes(id)) {
    const ins = new jingtaiV2Driver(protocol)
    await ins.init()
    return ins
  }
  throw new Error('Not support device')
}
